<div *ngIf="!permitido" style="width: 100%;text-align: center;">
  <span style="font-weight: bolder;font-family: 'Roboto';">Senha de Acesso</span><br>
    <input style="width: 350px;" type="password" pInputText [(ngModel)]="valSenha"> <br>
    <button pButton type="button" pTooltip="Clique para efetuar login"  tooltipPosition="right" (click)="entrar()" label="Entrar" class="ui-button-rounded ui-button-success" ></button>
</div>

<div *ngIf="permitido">


  <div class="p-grid">
  
    <div class="p-col-12" style="text-align: center;" *ngIf="!licitacaoSelecionada">
      <button pButton type="button" pTooltip="Clique para adicionar um novo processo licitatório"  tooltipPosition="right" (click)="adicionarNovo()" label="Adicionar Novo" class="ui-button-rounded ui-button-success" ></button>
    </div>
  </div>
  
  
    <p-fieldset legend="Cadastro de Evento" *ngIf="!licitacaoSelecionada">
      <div class="p-grid" *ngIf="mostrar">
    <div class="p-col-2">
      <!-- <h3 class="first" >Nome* </span> -->
      <span class="mostradores" pTooltip="Data do processo - serão ordenados por data" tooltipPosition="top">Data*</span> 
      <input  style="width: 100%;" type="date" pInputText [(ngModel)]="dia">
      
  </div>
  
  <div class="p-col-3">
    <span style="font-weight: bolder">Descrição*</span>
    <input style="width: 100%;" pInputText [(ngModel)]="descricao">
    
  </div>

  <div class="p-col-3">
    <span style="font-weight: bolder">Categoria*</span>
    <p-dropdown [options]="categorias" [style]="{'width':'100%'}" [(ngModel)]="categoria"></p-dropdown>
    
  </div>
  
  <div class="p-col-2">
    <button pButton type="button" style="margin-top: 15px;" pTooltip="Clique para Salvar"  tooltipPosition="right" (click)="salvar()" label="Salvar" class="ui-button-rounded ui-button-success" ></button>
  </div>
  </div>
  </p-fieldset>
  
  <p-tabView *ngIf="!licitacaoSelecionada">
    <p-tabPanel header="Ativas">
      <p-table [value]="licitacoes" sortMode="multiple" 
      (sortFunction)="customSort($event)" [customSort]="true">
          <ng-template pTemplate="header">
              <tr >
                  <th [pSortableColumn]="'dia'" style="width: 150px;" pTooltip="Data utilizada para ordenação." tooltipPosition="top" >Data</th>
                  <th [pSortableColumn]="'descricao'" pTooltip="Descrição."  tooltipPosition="top" >Descrição</th>
                  <th [pSortableColumn]="'categoria'" pTooltip="Descrição."  tooltipPosition="top" >Categoria</th>
                  
                  <th  pTooltip="Ações" style="width: 150px;" tooltipPosition="top" >Ações</th>
                  
                  
                  
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-d>
              <tr class="tabelaPequena">
                  <td >{{d.dia | dataMomento}}</td>
                  <td style="text-align: right;margin-right: 4px;">{{d.descricao  }}</td>
                  <td style="text-align: right;margin-right: 4px;">{{d.categoria  }}</td>
                  
                  <td style="text-align: right;margin-right: 4px;text-align: center;">
                    <img src="assets/plus.png" pTooltip="Inserir Arquivos." tooltipPosition="left" style="width: 28px;cursor: pointer;" (click)="inserirArquivos(d)">
                    <img src="assets/ok.png" pTooltip="Finalizar Licitação." tooltipPosition="left" style="width: 28px;cursor: pointer;" (click)="finalizarLicitacao(d)">
                  </td>
                  
                  
                  
              </tr>
          </ng-template>
  
          
  
          
      </p-table>
    </p-tabPanel>
    <p-tabPanel header="Finalizadas">
      <p-table [value]="desativas" sortMode="multiple" 
      (sortFunction)="customSort($event)" [customSort]="true">
          <ng-template pTemplate="header">
              <tr >
                  <th [pSortableColumn]="'dia'" style="width: 150px;" pTooltip="Data utilizada para ordenação." tooltipPosition="top" >Data</th>
                  <th [pSortableColumn]="'descricao'" pTooltip="Descrição."  tooltipPosition="top" >Descrição</th>
                  
                  <th  pTooltip="Ações" style="width: 150px;" tooltipPosition="top" >Ações</th>
                  
                  
                  
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-d>
              <tr class="tabelaPequena">
                  <td >{{d.dia | dataMomento}}</td>
                  <td style="text-align: right;margin-right: 4px;">{{d.descricao  }}</td>
                  
                  <td style="text-align: right;margin-right: 4px;text-align: center;">
                    <img src="assets/undo.png" pTooltip="Rativar Licitação." tooltipPosition="left" style="width: 28px;cursor: pointer;" (click)="reativar(d)">
                    <img src="assets/minus.png" pTooltip="Excluir Licitação." tooltipPosition="left" style="width: 28px;cursor: pointer;" (click)="excluir(d)">
                  </td>
                  
                  
                  
              </tr>
          </ng-template>
  
          
  
          
      </p-table>
    </p-tabPanel>
    
  </p-tabView>
  
  <hr>
  
  <div *ngIf="licitacaoSelecionada">
    <app-cadastro [licitacaoKey]="true" [licitacao]="licitacaoSelecionada" (volt)="voltar($event)"></app-cadastro>
  </div>
  
  

</div>

